import React from 'react';
import './styles/pricing.css';
import { useNavigate } from 'react-router-dom';
import whatsapp from '../img/zap.svg';
import email from '../img/email.svg';

const Pricing = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('.registration-section');
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <div className="pricing-page">
      <section className="pricing-hero">
        <h1>Pricing</h1>
        <p>Transparent and competitive pricing for your FBA prep needs</p>
      </section>

      <div className="pricing-container">
        {/* Basic Rate */}
        <section className="pricing-section">
          <div className="section-header">
            <h2>Basic Rate</h2>
            <div className="main-price">$0.75 <span>per unit</span></div>
          </div>
          <div className="section-content">
            <h3>Included:</h3>
            <ul>
              <li>Receiving & Inspection</li>
              <li>FNSKU Labeling</li>
              <li>Sticker Removal</li>
              <li>Pickup Arrangements (UPS, USPS, FedEx, etc.)</li>
            </ul>
          </div>
        </section>

        {/* Additional Services */}
        <section className="pricing-section">
          <div className="section-header">
            <h2>Additional Services</h2>
          </div>
          <div className="section-content">
            <div className="price-grid">
              <div className="price-item">
                <span className="item-name">Poly Bag with Suffocation Warning</span>
                <span className="item-price">$0.25</span>
              </div>
              <div className="price-item">
                <span className="item-name">Bubble Wrapping</span>
                <span className="item-price">$0.40</span>
              </div>
              <div className="price-item">
                <span className="item-name">Oversize Packaging</span>
                <span className="item-price">$1.00</span>
              </div>
              <div className="price-item">
                <span className="item-name">Box Shipping</span>
                <span className="item-price">$4.00</span>
              </div>
              <div className="price-item">
                <span className="item-name">Pallet</span>
                <span className="item-price">$45.00</span>
              </div>
              <div className="price-item">
                <span className="item-name">Picture Requested</span>
                <span className="item-price">$2.00</span>
              </div>
              <div className="price-item">
                <span className="item-name">Returns Receiving</span>
                <span className="item-price">$2.00 per unit</span>
              </div>
              <div className="price-item">
                <span className="item-name">Disposing</span>
                <span className="item-price">$0.50 per unit</span>
              </div>
              <div className="price-item">
                <span className="item-name">Storage - Box up to 24x24x24</span>
                <span className="item-price">$15.00/month</span>
              </div>
              <div className="price-item">
                <span className="item-name">Storage - Pallet (<strong>first month free</strong>)</span>
                <span className="item-price">$25.00/month</span>
              </div>
            </div>
          </div>
        </section>

        {/* Bulk Pricing */}
        <section className="pricing-section special">
          <div className="section-header">
            <h2>Bulk Pricing & Negotiation</h2>
          </div>
          <div className="section-content">
            <p>
              Please contact us for your inquiry. Many factors must be taken into consideration 
              when it comes to Fulfilled by Merchant, and pricing depends greatly on the specific 
              requirements and details of your product.
            </p>
            <p>
              We are open to discuss and negotiate our fees if you have <strong>more than 500 units per month</strong>.
            </p>
            <p>
              Please send us a message by <strong>WhatsApp or email</strong>, and we will get back to you as soon as possible.
            </p>
          </div>
          <div className="contact-buttons">
          <a 
            href="https://wa.me/14076932200" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-btn whatsapp-btn"
          >
            <img src={whatsapp} alt="WhatsApp" />
            <span>WhatsApp</span>
          </a>
          
          <a 
            href="mailto:contact@precisepreps.com" 
            className="contact-btn email-btn"
          >
            <img src={email} alt="Email" />
            <span>Email</span>
          </a>
        </div>
        </section>
      </div>

      {/* CTA */}
      <div className="pricing-cta">
        <button onClick={handleGetStarted} className="get-started-btn">
          Get Started
        </button>
      </div>
    </div>
  );
};

export default Pricing;